import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './reducer/RootReducer';

export const store = configureStore
    ({
        reducer: rootReducer,
    })